// Podcast catalog for the Av Library "Listen and learn" page.
// Extracted verbatim from the pre-refactor PodcastChannelsPage.js.

export const PODCASTS = [
  {
    slug: 'scam-inc',
    title: 'Scam Inc',
    image: '/images/Feb18ServerSideRefactorImages/PodcastScamInc.png',
    abstract:
      'A sophisticated, predatory, multi-billion-dollar industry is emerging from the shadows. It already rivals the size of the illicit drug trade. And it\u2019s about to get bigger and much more powerful. The Economist\u2019s Sue-Lin Wong follows the trail to the dark heart of this fast-growing criminal enterprise.',
    hostLabel: 'Reporter',
    hostName: 'Sue-Lin Wong',
    listenUrl: 'https://www.economist.com/audio/podcasts/scam-inc',
  },
  {
    slug: 'the-perfect-scam',
    title: 'The Perfect Scam',
    image: '/images/Feb18ServerSideRefactorImages/PodcastThePerfectScam.jpeg',
    abstract:
      'Weekly podcast tells the stories of people who find themselves the target of a scam. Introduces listeners to those who have experienced scams firsthand, as well as leading experts who pull back the curtain on how scammers operate.',
    hostLabel: 'Host',
    hostName: 'Bob Sullivan',
    listenUrl: 'https://www.aarp.org/podcasts/the-perfect-scam.html',
  },
  {
    slug: 'anatomy-of-a-scam',
    title: 'Anatomy of a Scam',
    image: '/images/Feb18ServerSideRefactorImages/PodcastAnatomyOfAScam.png',
    abstract:
      'Understanding how scammers target us with methods old and new, aided by cutting-edge technology, is the first step towards recognizing a scam in the wild and taking the necessary steps to stop it.',
    hostLabel: 'Host',
    hostName: 'Deborah Knight',
    listenUrl: 'https://open.spotify.com/show/4l4vG4PIcnaGUcaAVJsufr',
  },
];

export const podcastBySlug = (slug) => PODCASTS.find((p) => p.slug === slug) || null;
